// Bookings module schema has moved to @voyant-travel/bookings (packages/bookings/src/schema.ts)
export {}
